export class ApiError extends Error {
  readonly status: number;
  readonly code: number;
  readonly path?: string;

  constructor(status: number, code: number, message: string, path?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.path = path;
  }

  isUnauthorized(): boolean {
    return this.status === 401 || this.code === 40101 || this.code === 40103;
  }

  isForbidden(): boolean {
    return this.status === 403;
  }

  isRateLimited(): boolean {
    return this.status === 429;
  }
}

export class NetworkError extends Error {
  override readonly cause?: unknown;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = 'NetworkError';
    this.cause = cause;
  }
}
